import { CLEAR_SITE_DATA } from '../application';
import {
  RECEIVE_ALARMS,
  ALARM_UPDATED,
  ALARM_DELETED,
  SET_ALARMS_LOADING,
  FETCH_EXPORT_ALARMS,
  EXPORT_ALARMS_DONE,
  RECEIVE_ALARM_SOURCE_EVENTS,
  SET_SOURCE_EVENTS_LOADING,
  RECEIVE_ALARM_LOGBOOK,
  SET_LOGBOOK_LOADING,
  RECEIVE_NOTIFY_ALARMS,
} from './actions';

const initialState = {
  newAlarms: [],
  acknowledgedAlarms: [],
  resolvedAlarms: [],
  newAlarmsTotal: 0,
  acknowledgedAlarmsTotal: 0,
  resolvedAlarmsTotal: 0,
  isLoading: false,
  isExporting: false,
  sourceEventsByAlarmId: {},
  logbookByAlarmId: {},
  notifiedAlarmIds: {},
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case RECEIVE_ALARMS: {
      const { alarms, state: alarmState, offset = 0, total = 0 } = action;

      const appendOrReplace = (existingList) => {
        return offset > 0
          ? [...existingList, ...alarms] // Append
          : alarms; // Replace
      };

      switch (alarmState) {
        case 'new': {
          return {
            ...state,
            newAlarms: appendOrReplace(state.newAlarms),
            newAlarmsTotal: total,
          };
        }
        case 'acknowledged': {
          return {
            ...state,
            acknowledgedAlarms: appendOrReplace(state.acknowledgedAlarms),
            acknowledgedAlarmsTotal: total,
          };
        }
        case 'resolved': {
          return {
            ...state,
            resolvedAlarms: appendOrReplace(state.resolvedAlarms),
            resolvedAlarmsTotal: total,
          };
        }
        default: {
          return state;
        }
      }
    }
    case ALARM_UPDATED: {
      const { alarm } = action;
      // Remove alarm from its previous state list and add to new state list
      const removeFromList = (list) => list.filter((a) => a.id !== alarm.id);

      const newState = {
        ...state,
        newAlarms: removeFromList(state.newAlarms),
        acknowledgedAlarms: removeFromList(state.acknowledgedAlarms),
        resolvedAlarms: removeFromList(state.resolvedAlarms),
      };

      // Add to appropriate list based on alarm state
      switch (alarm.state) {
        case 'new': {
          newState.newAlarms = [alarm, ...newState.newAlarms];
          break;
        }
        case 'acknowledged': {
          newState.acknowledgedAlarms = [alarm, ...newState.acknowledgedAlarms];
          break;
        }
        case 'resolved': {
          newState.resolvedAlarms = [alarm, ...newState.resolvedAlarms];
          break;
        }
        default: {
          break;
        }
      }

      return newState;
    }
    case ALARM_DELETED: {
      const { alarmId } = action;
      const removeFromList = (list) => list.filter((a) => a.id !== alarmId);
      return {
        ...state,
        newAlarms: removeFromList(state.newAlarms),
        acknowledgedAlarms: removeFromList(state.acknowledgedAlarms),
        resolvedAlarms: removeFromList(state.resolvedAlarms),
        resolvedAlarmsTotal: Math.max(0, state.resolvedAlarmsTotal - 1),
      };
    }
    case SET_ALARMS_LOADING: {
      return { ...state, isLoading: action.loading };
    }
    case FETCH_EXPORT_ALARMS: {
      return { ...state, isExporting: true };
    }
    case EXPORT_ALARMS_DONE: {
      return { ...state, isExporting: false };
    }
    case SET_SOURCE_EVENTS_LOADING: {
      const { alarmId, loading } = action;
      return {
        ...state,
        sourceEventsByAlarmId: {
          ...state.sourceEventsByAlarmId,
          [alarmId]: {
            ...state.sourceEventsByAlarmId[alarmId],
            loading,
          },
        },
      };
    }
    case RECEIVE_ALARM_SOURCE_EVENTS: {
      const { alarmId, events, total } = action;
      return {
        ...state,
        sourceEventsByAlarmId: {
          ...state.sourceEventsByAlarmId,
          [alarmId]: {
            events,
            total,
            loading: false,
          },
        },
      };
    }
    case SET_LOGBOOK_LOADING: {
      const { alarmId, loading } = action;
      return {
        ...state,
        logbookByAlarmId: {
          ...state.logbookByAlarmId,
          [alarmId]: {
            ...state.logbookByAlarmId[alarmId],
            loading,
          },
        },
      };
    }
    case RECEIVE_ALARM_LOGBOOK: {
      const { alarmId, alarms, total } = action;
      return {
        ...state,
        logbookByAlarmId: {
          ...state.logbookByAlarmId,
          [alarmId]: {
            alarms,
            total,
            loading: false,
          },
        },
      };
    }
    case RECEIVE_NOTIFY_ALARMS: {
      return {
        ...state,
        notifiedAlarmIds: action.notifiedAlarmIds,
      };
    }
    case CLEAR_SITE_DATA: {
      return structuredClone(initialState);
    }
    default: {
      return state;
    }
  }
}
